import { Box, Text } from '@ghq-abi/design-system';

export function EmptyState() {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        textAlign: 'center',
        padding: '$8',
      }}
    >
      <Text
        css={{
          fontSize: '$xl',
          fontWeight: '$semibold',
          color: '$gray700',
        }}
      >
        No tickets found
      </Text>
    </Box>
  );
}
